import React from 'react';
import { Row, Col } from 'react-bootstrap';
import AboutBannerImg from '../assets/images/about-banner.png';

const AboutBanner = ({ section, imageUrl }) => {
  const title = section?.title || 'Your trusted home for getting home';
  const descriptionLines = section?.description
    ? section.description.split(/\r?\n/).filter(Boolean)
    : [
        'Jambobay is the housing super app — an ecosystem of products and services designed to provide a seamless, end-to-end transaction experience for renters, shoppers, buyers and sellers, as well as the real estate professionals who serve them.',
      ];
  const subDescription = section?.sub_description || 'Jambobay has been helping people get homes.';

  return (
    <section className="about-banner-section">
      <Row>
        <Col lg={6} md={12} className='about-content-box align-self-center'>
          <div className="about-content">
            <h1 className="about-title">
              {title.split(/\r?\n/).map((line, index) => (
                <React.Fragment key={index}>
                  {line}
                  {index < title.split(/\r?\n/).length - 1 ? <br /> : null}
                </React.Fragment>
              ))}
            </h1>
            {descriptionLines.map((line, index) => (
              <p className="about-description" key={index}>
                {line}
              </p>
            ))}
            <p className="about-subtitle">{subDescription}</p>
          </div>
        </Col>
        <Col lg={6} md={12}>
          <div className="about-image">
            <img
              src={imageUrl || AboutBannerImg}
              alt="Modern House"
              className="house-img"
            />
          </div>
        </Col>
      </Row>
    </section>
  );
};

export default AboutBanner;